// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.copySymbol {
  width: 15px;
  margin-right: 12px;
}

.copyButtonCode {
  border: none;
  background: none;
  display: flex;
  cursor: pointer;
  font-size: 14px;
  font-family: system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto,
    Oxygen, Ubuntu, Cantarell, "Open Sans", "Helvetica Neue", sans-serif;
  color: #078290;
  font-weight: 700;
  text-transform: uppercase;
}

.deploymentContainer h2.user-path {
  margin: 0;
  padding: 0;
  color: #4a88b1;
  font-size: 14px;
  font-weight: normal;
  font-family: system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto,
    Oxygen, Ubuntu, Cantarell, "Open Sans", "Helvetica Neue", sans-serif;
}

.user-path-title {
  font-weight: bold;
  color: #185177;
}

.arrow-icon {
  margin-left: 8px;
  margin-top: -3px;
  margin-right: 8px;
  width: 16px;
  height: 16px;
  vertical-align: middle;
}

.paragraph-ports {
  margin-top: 26px;
  margin-bottom: 16px;
}

.paragraph-final {
  margin-top: 26px;
  margin-bottom: 26px;
}

.deploymentContainer h4 {
  text-decoration: none !important;
  margin: 35px 0;
}

.automated-deployment {
  padding-top: 105px !important;
}
`, "",{"version":3,"sources":["webpack://./src/pages/Beacon2RIAPI/AutomatedDeployment.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,aAAa;EACb,eAAe;EACf,eAAe;EACf;wEACsE;EACtE,cAAc;EACd,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,SAAS;EACT,UAAU;EACV,cAAc;EACd,eAAe;EACf,mBAAmB;EACnB;wEACsE;AACxE;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;EACjB,WAAW;EACX,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,gCAAgC;EAChC,cAAc;AAChB;;AAEA;EACE,6BAA6B;AAC/B","sourcesContent":[".copySymbol {\n  width: 15px;\n  margin-right: 12px;\n}\n\n.copyButtonCode {\n  border: none;\n  background: none;\n  display: flex;\n  cursor: pointer;\n  font-size: 14px;\n  font-family: system-ui, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto,\n    Oxygen, Ubuntu, Cantarell, \"Open Sans\", \"Helvetica Neue\", sans-serif;\n  color: #078290;\n  font-weight: 700;\n  text-transform: uppercase;\n}\n\n.deploymentContainer h2.user-path {\n  margin: 0;\n  padding: 0;\n  color: #4a88b1;\n  font-size: 14px;\n  font-weight: normal;\n  font-family: system-ui, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto,\n    Oxygen, Ubuntu, Cantarell, \"Open Sans\", \"Helvetica Neue\", sans-serif;\n}\n\n.user-path-title {\n  font-weight: bold;\n  color: #185177;\n}\n\n.arrow-icon {\n  margin-left: 8px;\n  margin-top: -3px;\n  margin-right: 8px;\n  width: 16px;\n  height: 16px;\n  vertical-align: middle;\n}\n\n.paragraph-ports {\n  margin-top: 26px;\n  margin-bottom: 16px;\n}\n\n.paragraph-final {\n  margin-top: 26px;\n  margin-bottom: 26px;\n}\n\n.deploymentContainer h4 {\n  text-decoration: none !important;\n  margin: 35px 0;\n}\n\n.automated-deployment {\n  padding-top: 105px !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
